import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput.js'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import '@isceco/widget-library2/basic-elements/Form/Form.js'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog.js'
import WebComponent from '../../WebComponent.js'
import I18n from '../../i18n.js'
import AdminService from '../../services/AdminService.js'

export default class Kundensegmentierung extends WebComponent {

  static get EVENT_KEYS() {
    return {
      RELOAD_TRIGGERED: 'kundensegmentierung-reload-triggered'
    }
  }

  get css() {
    return css`
      isceco-title:first-of-type {
        display: block;
        margin-top: -20px;
        margin-bottom: -15px;
      }

      .flexRowView {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
      }

      .segmentierung-container {
        overflow-x: scroll;
        margin-left: 90px;
      }

      .segmentierung-header {
        align-self: end;
        text-align: center;
      }

      .segmentierung-header p {
        font-weight: bold;
        margin-top: 5px;
        margin-bottom: 10px;
      }

      .segmentierung-header span {
        font-size: 0.8em;
      }

      .segmentierung-row {
        display: flex;
        gap: 10px;
        align-items: center;
        margin-bottom: 6px; /* inputs have a top margin of 4px -> 10px total */
      }

      .segmentierung-row > * {
        flex: 1 0 80px;
      }

      .monat {
        width: 80px;
        text-align: right;
        position: absolute;
        transform: translateX(-90px);
      }

      .divider {
        flex: 0;
        align-self: stretch;
        width: 1px;
        padding: 10px 0;
        margin: -10px 0;
        border-right: 1px solid var(--isceco-color-grey-700);
      }
    `
  }

  get translationFile() {
    return './views/Admin/i18n.json'
  }

  constructor() {
    super()
    this.adminService = new AdminService()
    this.data = {}
    this.inputValid = []
    this.nextUrl = ''
  }

  connectedCallback() {
    super.connectedCallback()

    this._refresh = () => {
      send(Kundensegmentierung.EVENT_KEYS.RELOAD_TRIGGERED)
      this._loadData()
    }
    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)

    this._loadData()
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)
  }

  _loadData() {
    this.adminService.list('kundensegmentierung')
      .then(kapazitaeten => {
        this.data = kapazitaeten
        this.render()
      })
      .catch(_ => this.reload())
  }

  getTemplate() {
    return html`
      <isceco-title text="${this.i18n.translate('admin.kundensegmentierung.title')}">
        <nav class="kapazitaet-title-navigation">
          <div class="flexRowView">
            <isceco-button
              id="kundensegmentierung-speichern"
              variant="primary"
              size="small"
              icon="save"
              title="${this.i18n.translate('admin.kundensegmentierung.button.speichern.title')}"
              @click="${_ => {
                if (this.inputValid.length === 0 && document.getElementById("kundensegmentierung-form").validate()) {
                  document.getElementById('kundensegmentierung-confirm-dialog').removeAttribute('hidden')
                }
              }}"
            ></isceco-button>
          </div>
        </nav>
      </isceco-title>

      <p>${this.i18n.translate('admin.kundensegmentierung.aktualisiert')} ${this.getModTime()}</p>
      <isceco-form id="kundensegmentierung-form"
                   prevent-navigation
                   @abort="${event => this.handleAbort(event)}"
      >
        <div slot="form-elements" class="segmentierung-container">
          <div class="segmentierung-row">
            <div class="segmentierung-header monat"></div>
            ${this.getHeaderGroup('AIL')}
            ${this.getHeaderGroup('EGO')}
            ${this.getHeaderGroup('EGZ')}
            ${this.getHeaderGroup('Gaznat')}
            ${this.getHeaderGroup('GVM')}
          </div>
          <!-- Rows -->
          ${this.data.map((row, index) => html`
            <div class="segmentierung-row">
              <div id="monat-${index}" class="monat" style="text-align: right">${row.monatName}</div>
              ${this.getGridRow(row, index)}
            </div>
          `)}
        </div>
      </isceco-form>

      <isceco-dialog
        hidden
        header="${this.i18n.translate('admin.kundensegmentierung.confirm.header')}"
        id="kundensegmentierung-confirm-dialog"
        confirm-button="${this.i18n.translate('admin.kundensegmentierung.confirm.confirm')}"
        Cancel-button="${this.i18n.translate('admin.kundensegmentierung.confirm.cancel')}"
        @submit="${confirmed => this._close(confirmed)}">
      </isceco-dialog>
      <isceco-dialog id="abort-dialog"
                     hidden
                     header="${this.i18n.translate('admin.confirm.changes.dialog.titel')}"
                     description="${this.i18n.translate('admin.confirm.changes.dialog.beschreibung')}"
                     confirm-button="${this.i18n.translate('admin.confirm.changes.dialog.bestaetigen')}"
                     cancel-button="${this.i18n.translate('admin.confirm.changes.dialog.abbrechen')}"
                     @submit="${event => this.confirmAbort(event)}"
      ></isceco-dialog>
    `
  }

  getHeaderGroup(bilanzzone) {
    return html`
      <div class="segmentierung-header">
        <span>${this.i18n.translate('admin.kundensegmentierung.2Stoff')}</span>
      </div>
      <div class="segmentierung-header">
        <p>${bilanzzone}</p>
        <span>${this.i18n.translate('admin.kundensegmentierung.1StoffUngesch')}</span>
      </div>
      <div class="segmentierung-header">
        <span>${this.i18n.translate('admin.kundensegmentierung.1StoffGesch')}</span>
      </div>
      <div class="divider"></div>
    `
  }

  getModTime() {
    const modDates = this.data.map(obj => new Date(obj.modificationDate))
    return html`${formatDateTime(Math.max.apply(null, modDates))}`
  }

  getGridRow(month, index) {
    return html`
      ${this.getNumberInputs(index, 'ail', month.ail2Stoff, month.ail1StoffUngesch, month.ail1StoffGesch)}
      ${this.getNumberInputs(index, 'ego', month.ego2Stoff, month.ego1StoffUngesch, month.ego1StoffGesch)}
      ${this.getNumberInputs(index, 'egz', month.egz2Stoff, month.egz1StoffUngesch, month.egz1StoffGesch)}
      ${this.getNumberInputs(index, 'gaznat', month.gaznat2Stoff, month.gaznat1StoffUngesch, month.gaznat1StoffGesch)}
      ${this.getNumberInputs(index, 'gvm', month.gvm2Stoff, month.gvm1StoffUngesch, month.gvm1StoffGesch)}
    `
  }

  getNumberInputs(index, bilanzzone, value1, value2, value3) {
    return html`
      <isceco-number-input name="${bilanzzone}-${index}"
                           maximum-fraction-digits="1" min="0" max="100"
                           required
                           value="${value1}"
                           @change="${e => this.updateValue(index, bilanzzone, '2Stoff', e)}"></isceco-number-input>
      <isceco-number-input name="${bilanzzone}-${index}"
                           maximum-fraction-digits="1" min="0" max="100"
                           required
                           value="${value2}"
                           @change="${e => this.updateValue(index, bilanzzone, '1StoffUngesch', e)}"></isceco-number-input>
      <isceco-number-input name="${bilanzzone}-${index}"
                           maximum-fraction-digits="1" min="0" max="100"
                           required
                           value="${value3}"
                           @change="${e => this.updateValue(index, bilanzzone, '1StoffGesch', e)}"></isceco-number-input>
      <div class="divider"></div>
    `
  }

  updateValue(index, bilanzzone, key, event) {
    this.data[index][bilanzzone + key] = event.detail.value

    this.validateInputGroup(document.getElementsByName(`${bilanzzone}-${index}`))
  }

  validateInputGroup(inputs) {
    const sum = this.getSum(inputs)
    const firstInput = inputs[0]
    const inputName = firstInput.getAttribute('name')

    if (sum === 100) {
      firstInput.classList.remove('error')
      this.inputValid.splice(this.inputValid.indexOf(inputName),1)
    } else {
      if (this.inputValid.indexOf(inputName) === -1) {
        this.inputValid.push(inputName)
      }
      firstInput.message = this.i18n.translate('admin.kundensegmentierung.form.error.total100')
      firstInput.classList.add('error')
    }
    firstInput.requestUpdate()
  }

  getSum(inputs) {
    const values = Array.from(inputs).map(inp => Number(inp.value))
    return values.reduce((a, b) => a + b, 0)
  }

  _close(e) {
    e.target.hidden = true
    if (e.detail.confirmed) {
      this._save()
    }
  }

  _save() {
    this.adminService.updateList(this.data, 'kundensegmentierung')
      .then(() => {
        // Reset the valueChanged from the form inputs, data are already saved in another way
        const formElements = document.querySelector('#kundensegmentierung-form').getFormElements();
        if (formElements) {
          formElements.forEach(element => {element.valueChanged = false})
        }
        showAlert(this.i18n.translate('admin.kundensegmentierung.createupdate.success'), '', 'success')
        this._refresh()
      })
      .catch(() => {
        showAlert(this.i18n.translate('admin.kundensegmentierung.createupdate.failure'), '', 'error')
        this.render()
      })
  }

  handleAbort = event => {
    const dialog = document.querySelector('#abort-dialog')
    dialog.hidden = false
    this.nextUrl = event.detail.url ?? '#Cockpit'
  }

  confirmAbort = event => {
    if (event.detail.confirmed) {
      navigate({to: this.nextUrl, allow: true})
    } else {
      event.target.hidden = true
    }
  }
}
customElements.define('gasmonitoring-frontend-admin-kundensegmentierung', Kundensegmentierung)
